import { CHECK_REGISTER, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    checkRegister: false
}

export const checkRegister = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_REGISTER:
            return {
                ...state,
                checkRegister: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}